export const CLOUD_MEV_ENVIRONMENTS = ["DEV", "ESSAI", "PROD"] as const;

export type CloudMevEnv = (typeof CLOUD_MEV_ENVIRONMENTS)[number];

export const normalizeCloudMevEnv = (value?: string | null): CloudMevEnv => {
  const next = String(value || "DEV").trim().toUpperCase();
  if (next === "PROD" || next === "ESSAI") return next;
  return "DEV";
};

export const cloudMevEnvStorageKey = (storeId?: string | null) => {
  const id = String(storeId || "").trim();
  return id ? `cloudMevEnvirn_${id}` : "cloudMevEnvirn";
};

function currentStoreId(): string {
  try {
    return localStorage.getItem("selectedStoreId") || localStorage.getItem("currentStoreId") || "";
  } catch {
    return "";
  }
}

function unscopedEnv(): string {
  try {
    return localStorage.getItem("cloudMevEnvirn") || localStorage.getItem("envirn") || "";
  } catch {
    return "";
  }
}

export const readStoredCloudMevEnv = (storeId?: string | null): CloudMevEnv | "" => {
  try {
    const id = String(storeId || currentStoreId() || "").trim();
    if (!id) {
      const loose = unscopedEnv();
      return loose ? normalizeCloudMevEnv(loose) : "";
    }
    const key = `cloudMevEnvirn_${id}`;
    const saved = localStorage.getItem(key);
    if (saved) return normalizeCloudMevEnv(saved);
    const loose = unscopedEnv();
    if (!loose) return "";
    const attached = normalizeCloudMevEnv(loose);
    localStorage.setItem(key, attached);
    return attached;
  } catch {
    return "";
  }
};

export const resolveCloudMevEnv = (storeValue?: string | null, storeId?: string | null): CloudMevEnv => {
  const stored = readStoredCloudMevEnv(storeId);
  const fromStore = String(storeValue || "").trim() ? normalizeCloudMevEnv(storeValue) : "";
  if (stored && stored !== "DEV") return stored;
  if (fromStore && fromStore !== "DEV") return fromStore;
  if (stored) return stored;
  if (fromStore) return fromStore;
  return "DEV";
};

export const writeStoredCloudMevEnv = (storeId: string | null | undefined, envirn: CloudMevEnv) => {
  try {
    const id = String(storeId || currentStoreId() || "").trim();
    if (id) localStorage.setItem(`cloudMevEnvirn_${id}`, envirn);
    localStorage.setItem("envirn", envirn);
    window.dispatchEvent(new CustomEvent("cloud-mev-envirn", { detail: envirn }));
  } catch {
    // Ignore storage errors.
  }
};
